module.exports = __webpack_public_path__ + "material-design.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/material-design/material-design.ttf?v=2.2.0
// module id = 894
// module chunks = 3